export const basicProgressSubTitle = [
    {
        text: 'Progress components are built with two HTML elements, some CSS to set the width, and a few attributes. We use the ',
        code: '.progress '
    },
    {
        text: 'as a wrapper to indicate the max value of the progress bar. The ',
        code: '.progress-bar '
    },
    {
        text: 'requires an inline style, utility class, or custom CSS to set their width.'
    }
];

export const stripedProgressSubTitle = [
    {
        text: 'Add ',
        code: '.progress-bar-striped'
    },
    {
        text: ' class to set the striped progress-bar',
    }
];

export const animetedProgressSubTitle = [
    {
        text: 'To set the animated progress-bar use ',
        code: '.progress-bar-animated'
    },
    {
        text: ' class.'
    }
];

export const multipleBarsSubTitle = [
    {
        text: 'To set the multiple progress-bar with the help of ',
        code: 'progress'
    },
    {
        text: 'class.'
    }
];

export const stepsBarTitleSubTitle = [
    {
        text: 'To set the number steps progress bar use ',
        code: '.position-wrapper '
    },
    {
        text: 'class.'
    }
];

export const customProgressSubTitle = [
    {
        text: 'Set the animated striped progress-bar with help of ',
        code: '.progress-bar-animated '
    },
    {
        text: '& ',
        code: '.progress-bar-striped '
    },
    {
        text: 'class.'
    }
];

export const smallProgressSubTitle = [
    {
        text: 'Use ',
        code: ' .sm-progress-bar'
    },
    {
        text: ' class to set the small size of progress bar.'
    }
];

export const largeProgressSubTitle = [
    {
        text: 'Set the large progress bar with the help of',
        code: ' .lg-progress-bar'
    },
    {
        text: '  class.'
    }
];

export const customSubTitle = [
    {
        text: 'customize the progress bar height with the help of giving height to bar.'
    }
];

export const basicProgressData = [
    {
        class: 'transparent',
        value: '0'
    },
    {
        class: 'primary',
        value: '25'
    },
    {
        class: 'secondary',
        value: '50'
    },
    {
        class: 'success',
        value: '75'
    },
    {
        class: 'danger',
        value: '100'
    }
];

export const stripedProgressData = [
    {
        class: 'primary',
        value: '10'
    },
    {
        class: 'warning',
        value: '25'
    },
    {
        class: 'danger',
        value: '50'
    },
    {
        class: 'success',
        value: '75'
    }
];

export const multipleBarData = [
    {
        data: [
            {
                class: 'primary',
                value: '30'
            },
            {
                class: 'secondary',
                value: '20'
            },
            {
                class: 'success',
                value: '15'
            }
        ]
    },
    {
        data: [
            {
                class: 'primary',
                value: '10'
            },
            {
                class: 'secondary',
                value: '10'
            },
            {
                class: 'success',
                value: '10'
            },
            {
                class: 'info',
                value: '10'
            },
            {
                class: 'warning',
                value: '10'
            },
            {
                class: 'danger',
                value: '10'
            },
            {
                class: 'primary',
                value: '10'
            },
            {
                class: 'warning',
                value: '10'
            }
        ]
    },
];

export const customProgressData = [
    {
        text: '0% Getting Started ',
        class: 'transparent',
        value: '0'
    },
    {
        text: '30% Getting Uploading...',
        class: 'primary',
        value: '30'
    },
    {
        text: '60% Getting Pause...',
        class: 'secondary',
        value: '60'
    },
    {
        text: '70% Getting Uploading...',
        class: 'success',
        value: '70'
    },
    {
        text: '100% Completed',
        class: 'dark',
        value: '100'
    }
];

export const smallProgressData = [
    {
        value: '30%',
        text: '30 MB Data'
    },
    {
        value: '50%',
        text: '50 MB Data'
    },
    {
        value: '75%',
        text: '75 MB Data'
    }
];

export const largeProgressData = [
    {
        class: 'primary',
        value: '25'
    },
    {
        class: 'secondary',
        value: '50'
    },
    {
        class: 'success',
        value: '75'
    },
    {
        class: 'info',
        value: '100'
    }
];

export const customSizesData = [
    {
        text: ' 1px',
        class: 'primary',
        value: '25'
    },
    {
        text: ' 5px',
        class: 'warning',
        value: '50'
    },
    {
        text: ' 11px',
        class: 'danger',
        value: '75'
    },
    {
        text: ' 19px',
        class: 'info',
        value: '100'
    }
]
